import { render, staticRenderFns } from "./AssessmentProcedure.vue?vue&type=template&id=506f0b5d&scoped=true"
import script from "./AssessmentProcedure.vue?vue&type=script&lang=js"
export * from "./AssessmentProcedure.vue?vue&type=script&lang=js"
import style0 from "./AssessmentProcedure.vue?vue&type=style&index=0&id=506f0b5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506f0b5d",
  null
  
)

export default component.exports